import {gql} from "@apollo/client";

export const SAVE_HOCKEY_PLAYER_SCORE = gql`
  mutation SaveHockeyPlayerScore($input: HockeyPlayerScoreInput!) {
    saveHockeyPlayerScore(input: $input) {
      score {
        id
        period
        minute
        second
        actionType
        penaltyType
        penaltyMinutes
        notes
        player { id fullName }
        relatedPlayer { id fullName }
        team { id name }
      }
    }
  }
`;

export const DELETE_HOCKEY_PLAYER_SCORE = gql`
  mutation DeleteHockeyPlayerScore($scoreId: Int!) {
    deleteHockeyPlayerScore(scoreId: $scoreId) {
      success
    }
  }
`;
